import React from 'react';
import { ChevronLeft } from 'lucide-react';
interface RelationshipType {
  id: string;
  name: string;
  description: string;
  icon: string;
}
interface Step3RelationshipProps {
  selectedRelationship: string;
  onSelect: (relationship: string) => void;
  onNext: () => void;
  onBack: () => void;
}
export const Step3Relationship: React.FC<Step3RelationshipProps> = ({
  selectedRelationship,
  onSelect,
  onNext,
  onBack
}) => {
  const relationships: RelationshipType[] = [{
    id: 'submissive_pet',
    name: 'Your Submissive Pet',
    description: 'She lives to please you and follows your every command',
    icon: '🐱'
  }, {
    id: 'boss',
    name: 'Your Boss',
    description: 'She takes charge and tells you what to do',
    icon: '👑'
  }, {
    id: 'sugar_baby',
    name: 'Your Sugar Baby',
    description: 'She loves being spoiled and will reward your generosity',
    icon: '💎'
  }, {
    id: 'flirty_roommate',
    name: 'Your Flirty Roommate',
    description: 'Living together creates constant tension and opportunities',
    icon: '🏠'
  }, {
    id: 'loving_milf',
    name: 'Your Loving MILF',
    description: 'Mature, experienced, and eager to take care of you',
    icon: '👩‍👦'
  }, {
    id: 'bitchy_ex',
    name: 'Your Bitchy Ex',
    description: "You broke up but can't stay away from each other",
    icon: '💔'
  }, {
    id: 'secret_crush',
    name: 'Your Secret Crush',
    description: 'The tension of forbidden desire makes everything exciting',
    icon: '🤫'
  }];
  const handleContinue = () => {
    if (selectedRelationship) {
      onNext();
    }
  };
  return <div className="space-y-6" data-id="element-22168">
      <div className="flex items-center mb-6" data-id="element-22169">
        <button onClick={onBack} className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800" data-id="element-22170">
          <ChevronLeft size={20} className="text-gray-500" data-id="element-22171" />
        </button>
        <div className="ml-4" data-id="element-22172">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-22173">
            Define Relationship
          </h2>
          <p className="text-gray-600 dark:text-gray-400" data-id="element-22174">
            How do you want to relate to your Angel?
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-4" data-id="element-22175">
        {relationships.map(relationship => <div key={relationship.id} onClick={() => onSelect(relationship.id)} className={`p-4 rounded-xl border cursor-pointer transition-all ${selectedRelationship === relationship.id ? 'border-pink-500 bg-pink-50 dark:bg-pink-900/20 shadow-md' : 'border-gray-200 dark:border-gray-700 hover:border-pink-300 dark:hover:border-pink-700 hover:shadow-sm'}`} data-id="element-22176">
            <div className="flex items-center" data-id="element-22177">
              <div className="text-2xl mr-4" data-id="element-22178">{relationship.icon}</div>
              <div data-id="element-22179">
                <h3 className="font-medium text-gray-900 dark:text-white" data-id="element-22180">
                  {relationship.name}
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-22181">
                  {relationship.description}
                </p>
              </div>
            </div>
          </div>)}
      </div>
      <div className="pt-6" data-id="element-22182">
        <div className="text-xs text-gray-500 dark:text-gray-400 mb-2 flex items-center" data-id="element-22183">
          <span className="w-4 h-4 inline-flex items-center justify-center bg-gray-200 dark:bg-gray-700 rounded-full mr-2 text-xs" data-id="element-22184">
            ?
          </span>
          Sets the emotional dynamic between you and your Angel
        </div>
        <button onClick={handleContinue} disabled={!selectedRelationship} className={`w-full py-3 rounded-lg font-medium text-white ${!selectedRelationship ? 'bg-gray-400 cursor-not-allowed' : 'bg-gradient-to-r from-pink-500 to-purple-600 hover:shadow-lg hover:shadow-pink-500/30 transition-all'}`} data-id="element-22185">
          Next: Choose a Job
        </button>
      </div>
    </div>;
};